<template>
    <div class="study-top">
        <div style="padding-top: 90px;">
            {{"最近学习课程"}}
        </div>
        <div class="content">
            <!-- tab切换 -->
            <div class="tabs2">
                <div class="one">
                    <div
                            class="one-item"
                            :class="{ studyActive: active == index }"
                            @click="change(index)"
                            v-for="(item, index) in semester"
                            :key="index"
                    >
                        {{ item.name
                        }}{{
                        item.have_in_hand == 0
                        ? "(未开启)"
                        : item.have_in_hand == 1
                        ? "(当前学期)"
                        : "(已结束)"
                        }}
                    </div>
                </div>
                <div class="two">
                    <div>开始时间：{{ start_time | dateFormat }}</div>
                    <div>结束时间：{{ end_time | dateFormat }}</div>
                    <!-- <div>课时：8/10</div> -->
                    <div>Tip：{{ tips }}</div>
                </div>
            </div>
            <!-- 切换的视图 -->
            <div class="changecontent">
                <div class="course" v-for="(item, index) in course1" :key="index">
                    <div class="courseIcon">
                        <div class="text">
                            {{
                            item.status == 0
                            ? "未通过"
                            : item.status == 2
                            ? "未开启"
                            : "已通过"
                            }}
                        </div>
                        <!-- <img  src="../../assets/img/study/studyHome/bg_1_3.png" alt /> -->
                        <img
                                v-if="item.column_status == 0"
                                src="../../assets/img/study/studyHome/bg_1_2.png"
                                alt
                        />
                        <img
                                v-if="item.column_status == 1"
                                src="../../assets/img/study/studyHome/bg_1_1.png"
                                alt
                        />
                        <img
                                v-if="item.column_status == 2"
                                src="../../assets/img/study/studyHome/bg_1_4.png"
                                alt
                        />
                    </div>
                    <div class="courseLeft">
                        <div class="courseImg">
                            <!--<img :src="urlImg + item.cover_img" alt />-->

                            <img src="../../assets/img/home/sc.jpg" alt/>
                        </div>
                        <div class="courseName">{{ item.name }}</div>
                    </div>
                    <div class="courseStep">
                        <div class="step">
                            <div class="stepName">课程总分</div>
                            <div class="stepNum" v-if="item.status == 2">----</div>
                            <div class="stepNum" v-else>
                <span
                        class="span1"
                        :class="{ span2: item.status == 1 }"
                >{{ item.totalScore/100}}</span>
                                /{{ item.score }}
                            </div>

                            <div class="btn1 btn3" v-if="item.status == 2">暂未开启</div>
                            <div class="stepExplain" v-else>{{ item.rate }}%即算合格</div>
                        </div>
                        <div class="step">
                            <div class="stepName">课程学习（{{item.learn}}/{{item.videos}}）</div>
                            <div class="stepNum" v-if="item.status == 2">----</div>
                            <div class="stepNum" v-else>
                <span
                        class="span1"
                        :class="{ span2: item.status == 1 }"
                >{{item.videoScore/100}}</span>
                                /{{ item.score * item.rates.studyRate /100 }}
                            </div>
                            <div class="btn1 btn4" v-if="item.status == 3">已结束</div>
                            <div class="btn1 btn3" v-else-if="item.status == 2">暂未开启</div>
                            <div class="btn1 btn2" v-else @click="openShade($event, 2, item.id)">继续学习</div>
                        </div>
                        <div class="step">
                            <div class="stepName">课程练习（{{item.doneExamNum}}/3）</div>
                            <div class="stepNum" v-if="item.status == 2">----</div>
                            <div class="stepNum" v-else>
                <span
                        class="span1"
                        :class="{ span2: item.status == 1 }"
                >{{ item.practiceScore/100 }}</span>
                                /{{ item.score * item.rates.practiceRate /100 }}
                            </div>
                            <div class="btn1 btn4" v-if="item.status == 3">已结束</div>
                            <div class="btn1 btn3" v-else-if="item.status == 2">暂未开启</div>
                            <div class="btn1 btn2" v-else @click="openShade($event, 3, item.id)">开始练习</div>
                        </div>
                        <div class="step">
                            <div class="stepName">课程考试（1/1）</div>
                            <div class="stepNum" v-if="item.status == 2">----</div>
                            <div class="stepNum" v-else>
                <span
                        class="span1"
                        :class="{ span2: item.status == 1 }"
                >{{ item.courseScore/100 }}</span>
                                /{{ item.score * item.rates.examRate /100 }}
                            </div>
                            <div class="btn1 btn4" v-if="item.status == 3">已结束</div>
                            <div class="btn1 btn3" v-else-if="item.status==2">暂未开启</div>
                            <div class="btn1 btn2" v-else @click="openShade($event,4,item.id)">开始考试</div>
                        </div>
                        <div class="step">
                            <div class="stepName">课程答疑（5/5）</div>
                            <div class="stepNum" v-if="item.status == 2">----</div>
                            <div class="stepNum" v-else>
                <span
                        class="span1"
                        :class="{ span2: item.status == 1 }"
                >{{ item.answerScore/100 }}</span>
                                /{{ item.score * item.rates.answerRate /100 }}
                            </div>
                            <div class="btn1 btn4" v-if="item.status == 3">已结束</div>
                            <div class="btn1 btn3" v-else-if="item.status == 2">暂未开启</div>
                            <div class="btn1 btn2" v-else @click="openShade($event,5,item.id)">开始答疑</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 遮罩层1-->

            <!-- 打开外层遮罩层 -->
            <el-dialog
                    custom-class="dialogOne"
                    :visible.sync="centerDialogVisible"
                    append-to-body
                    width="1200px"
                    center
            >
                <!-- 打开内层遮罩层 -->
                <el-dialog
                        width="567px"
                        style="border-radius: 15px"
                        :visible.sync="innerVisible"
                        top="40vh"
                        append-to-body
                >
                    <div class="con">确定开始练习试题吗</div>
                    <span slot="footer" class="dialog-footer interiorFooter">
            <div @click="close">取消</div>
            <div @click="goTxt" class="btn">确认</div>
          </span>
                </el-dialog>
                <!-- 遮罩层1的内容 -->
                <div class="dialogClose" @click="centerDialogVisible = false">
                    <i style="cursor: pointer" class="el-icon-error"></i>
                </div>
                <div class="diaTitle">课程练习</div>
                <div class="Exercise">
                    <div class="exerciseItem" v-for="(item, index) in exercise" :key="index">
                        <el-tooltip effect="dark" content="点击查看做题记录" placement="bottom-start">
                            <div class="itemIcon" @click="record($event,index,item.id)">
                                <img src="../../assets/img/study/exam/icon_1_7.png"/>
                            </div>
                        </el-tooltip>
                        <div class="kong"></div>
                        <div class="exerciseTop">
                            <div class="exerciseNum">
                                <div class="exerciseLogo">
                                    <img src="../../assets/img/study/exam/icon_1_6.png"/>
                                </div>
                                <div class="exerciseName">{{ item.examName }}</div>
                            </div>
                            <div class="explain">{{item.action}}</div>
                        </div>
                        <div class="exerciseBottom">
                            <div class="line"></div>
                            <div class="btmItem" v-if="!item.flag">
                                <div>卷面总分：{{ item.allScore }}</div>
                                <div>我的成绩：{{ item.maxScore }}</div>
                                <!--<div>学分：{{ item.score }}</div>-->
                                <div>剩余{{ item.remainingNum }}次机会</div>
                            </div>
                            <div class="btmItem1" v-else-if="item.flag&&item.recordList.length!=0">
                                <div
                                        class="recordItem"
                                        @click="analysis(item2.id)"
                                        v-for="(item2, index2) in item.recordList"
                                        :key="index2"
                                >
                                    <div>{{ item2.bookName }}</div>
                                    <div>{{ item2.examName }}</div>
                                </div>
                            </div>
                            <div class="without" v-else>暂无做题记录</div>
                        </div>
                        <div
                                class="diaBtn"
                                @click="openExam(item.id)"
                                :class="{ diaBtn1: item.status == 1 }"
                        >{{ item.status == 1 ? "已完成" : "开始练习" }}
                        </div>
                    </div>
                </div>
                <div class="tip">Tip：本课程共有三套练习试卷，每套试卷共有20次机会，最终考试成绩取最高分</div>
            </el-dialog>
            <!-- 遮罩层2 -->
            <!-- 打开外层遮罩层 -->
            <el-dialog
                    width="1200px"
                    custom-class="dialogTwo"
                    :visible.sync="centerDialogVisible1"
                    append-to-body
            >
                <!-- 打开内层遮罩层 -->
                <el-dialog
                        width="356px"
                        custom-class="dialogTwo-inside"
                        :visible.sync="innerVisible1"
                        top="40vh"
                        append-to-body
                >
                    <div class="con">确认进入试题考试吗</div>
                    <span slot="footer" class="dialog-footer interiorFooter">
            <div @click="close1">取消</div>
            <div @click="goTxt" class="btn">确认</div>
          </span>
                </el-dialog>
                <!-- 遮罩层内容 -->
                <div class="bgc">
                    <div class="dialogClose dialogClose1" @click="centerDialogVisible1 = false,flag = true">
                        <i style="cursor: pointer;" class="el-icon-error"></i>
                    </div>
                    <div class="dialog2">
                        <!-- 内容左侧 -->
                        <div class="dialogLeft2">
                            <div class="leftTop2">
                                <div>课程考试</div>
                                <div>{{exercise1.examName}}</div>
                                <div>总分：{{exercise1.allScore }}分</div>
                            </div>
                            <div class="leftMid2" v-if="flag">{{exercise1.examName}}</div>
                            <div class="leftMid2" v-else>
                                <div class="leftMidList2" v-for="(item, index) in recordList" :key="index">
                                    <div class="leftMid2-left">
                                        <div class="leftMid2-leftImg">
                                            <img src="../../assets/img/study/exam/icon_1_9.png"/>
                                        </div>
                                        <div>{{item.bookName}}</div>
                                        <div>{{item.examName}}</div>
                                    </div>
                                    <div @click="analysis(item.id)" class="leftMid2-right">查看详情</div>
                                </div>
                            </div>
                            <div class="leftBtn2">
                                <div @click="openExam1(exercise1.id)">开始考试</div>
                                <div @click="record1(exercise1.id)">考试记录</div>
                            </div>
                            <div class="leftBottom2">Tip：本次课程考试有{{exercise1.nums}}次机会，最终考试成绩取最高分</div>
                        </div>
                        <!-- 内容右侧 -->
                        <div class="dialogRight2">
                            <div class="dialogRight2-img">
                                <img src="../../assets/img/study/exam/icon_1_9.png"/>
                            </div>
                            <div>卷面总分：{{exercise1.allScore}}</div>
                            <div>我的成绩：{{exercise1.maxScore}}</div>
                            <!--<div>学分：</div>-->
                            <div>剩余{{exercise1.nums}}次机会</div>
                        </div>
                    </div>
                </div>
            </el-dialog>

            <!-- 遮罩层3 -->
            <!-- 打开外层遮罩层 -->
            <el-dialog
                    width="1200px"
                    custom-class="dialogThree"
                    :visible.sync="centerDialogVisible2"
                    append-to-body
            >
                <MyAnswer></MyAnswer>
            </el-dialog>
        </div>
    </div>
</template>
<script>
    import store from "store";
    import {studyIndex, courseExercises, makeNotes} from "../../assets/js/api.js";
    import MyAnswer from "./myCourseAnswer";

    export default {
        components: {MyAnswer},
        data() {
            return {
                active: 0,
                // 外层遮罩层
                centerDialogVisible: false,
                centerDialogVisible1: false,
                // 内层遮罩层
                innerVisible: false,
                innerVisible1: false,
                centerDialogVisible2: false,

                flag: true,
                // 后台返回的数据
                urlImg: "../../assets/img/home/p3.png",
                semester: [],
                course1: [],
                // 开始练习的遮罩层
                exercise: [],
                // 开始考试的遮罩层
                exercise1: "",
                start_time: "",
                end_time: "",
                tips: "",
                c_id: "",
                recordList: [],
                // 进入试卷的id
                c_e_id: "",
                img: "../../assets/img/home/p4.png",
                // 前端固定的假数据
                bannerList: [
                    // {
                    //   img: require("../../assets/img/home/p1.png"),
                    // },
                    // {
                    //   img: require("../../assets/img/home/p2.png"),
                    // },
                    // {
                    //   img: require("../../assets/img/home/p3.png"),
                    // },
                    // {
                    //   img: require("../../assets/img/home/p4.png"),
                    // },
                ],
            };
        },
        mounted() {
            this.bannerList = store.get("bannerImg");
            // console.log(this.bannerList)
            this.studyData();
            window.scroll(0, 0);
        },
        methods: {
            studyData() {
                studyIndex(window.localStorage.getItem("siteId"), window.localStorage.getItem("info")).then((res) => {
                    console.log(res)
                    if (res.code == 200) {
                        let i = 0;
                        res.data.terms.forEach((item, index) => {
                            if (item.have_in_hand == 0) {
                                item.myClasss.forEach((item1) => {
                                    item1.status = 2;
                                });
                            }
                            if (item.have_in_hand == 2) {
                                item.myClasss.forEach((item1) => {
                                    item1.status = 3;
                                });
                            }
                            if (item.have_in_hand == 1) {
                                i = index;
                                this.active = i;
                            }
                        });

                        this.semester = res.data.terms;
                        this.start_time = res.data.terms[i].beginTime * 1000;
                        this.end_time = res.data.terms[i].endTime * 1000;
                        this.course1 = res.data.terms[i].myClasss;
                        this.tips = res.data.terms[i].tips;

                        console.log(res.data)
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            },

            change(i) {
                this.active = i;
                this.start_time = this.semester[i].beginTime * 1000;
                this.end_time = this.semester[i].endTime * 1000;
                this.course1 = this.semester[i].myClasss;
                this.tips = this.semester[i].tips;
            },
            record(e, i, id) {
                this.exercise[i].flag = true;
                makeNotes(localStorage.getItem("siteId"), localStorage.getItem("info"), id).then((res) => {
                    if (res.code == 200) {
                        this.exercise[i].recordList = res.data.record;
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            },
            record1(id) {
                this.flag = false;
                makeNotes(localStorage.getItem("siteId"), localStorage.getItem("info"), id).then((res) => {
                    if (res.code == 200) {
                        this.recordList = res.data.record;
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            },
            openShade(e, status, id) {
                let type;
                this.c_id = id;
                if (status == 2) {
                    // 继续学习
                    this.$router.push({
                        path: "/video",
                        query: {
                            id: id,
                        },
                    });
                } else if (status == 3) {
                    // 开始练习
                    this.centerDialogVisible = true;
                    type = 3;
                    courseExercises(window.localStorage.getItem("siteId"), window.localStorage.getItem("info"), type, this.c_id).then((res) => {
                        res.data.forEach((item) => {
                            item.flag = false;
                            item.recordList = [];
                        });
                        this.exercise = res.data;
                    });
                } else if (status == 4) {
                    // 开始考试
                    this.centerDialogVisible1 = true;
                    type = 1;
                    courseExercises(window.localStorage.getItem("siteId"), window.localStorage.getItem("info"), type, this.c_id).then((res) => {
                        this.exercise1 = res.data[0];
                    });
                } else if (status == 5) {
                    // 进入答疑
                    this.centerDialogVisible2 = true;

                }
            },
            // 点击确定 进入试卷页面
            goTxt() {
                this.centerDialogVisible = false;
                this.innerVisible = false;
                this.centerDialogVisible1 = false;
                this.innerVisible1 = false;
                this.$router.push({path: "/exam", query: {c_e_id: this.c_e_id}});
            },
            openExam(id) {
                this.innerVisible = true;
                this.c_e_id = id;
            },
            openExam1(id) {
                this.innerVisible1 = true;
                this.c_e_id = id;

            },
            //跳转至错题解析
            analysis(id) {
                // this.$router.push({ path: "/analysis", query: {"examId":this.c_e_id, id: id } });
            },
            // 练习 取消 关闭遮罩层
            close() {
                this.innerVisible = false;
            },
            // 考试 取消 关闭遮罩层
            close1() {
                this.innerVisible1 = false;
            },
        },
    };
</script>
<style lang="less" scoped>
    /deep/ .el-dialog__headerbtn {
        display: none;
    }

    /deep/ .el-dialog__header {
        padding: 0;
    }

    .study-top {
        margin-top: 60px;
    }

    .banner {
        height: 70px;
    }

    .content {
        position: relative;
        top: -60px;
        margin: 0 auto;
        width: 1200px;
        z-index: 10;
        padding-top: 80px;
    }

    .tabs2 {
        height: 120px;
        line-height: 60px;
        border-radius: 15px;
        overflow-x: auto;
        .one {
            display: flex;
            height: 60px;
            background-color: #ff551b;
            width: 1200px;
            overflow-x: scroll;
            .one-item {
                cursor: pointer;
                text-align: center;
                min-width: 20%;
                // padding-left: 60px;
                box-sizing: border-box;
                color: #666666;
            }
            .studyActive {
                background-color: #ffa80a;
                color: #fff;
            }
        }
        .two {
            padding-left: 60px;
            display: flex;
            height: 60px;
            width: 100%;
            /*background-color: #029aff;*/
            opacity: 0.7;
            color: #ff551b;
            box-sizing: border-box;
            div {
                margin-right: 30px;
            }
        }
    }

    .course {
        position: relative;
        display: flex;
        align-items: center;
        margin-top: 30px;
        height: 217px;
        border-radius: 10px;
        overflow: hidden;
        .courseIcon {
            position: absolute;
            top: 0;
            left: 0;
            width: 103px;
            height: 44px;
            z-index: 2;
            .text {
                position: absolute;
                top: 6px;
                left: 6px;
                color: #fff;
            }
        }
    }

    .courseLeft {
        width: 217px;
        margin-left: 20px;
        .courseImg {
            width: 217px;
            height: 132px;
        }
        .courseName {
            margin-top: 8px;
            text-align: center;
            font-size: 18px;
            color: #333333;
        }
    }

    .courseStep {
        display: flex;
        width: 963px;
        font-size: 16px;
        color: #333333;
        .step {
            width: 25%;
            height: 100%;
            text-align: center;
            .stepNum {
                padding-top: 40px;
                padding-bottom: 40px;
                border-right: 1px solid #ccc;
                .span2 {
                    color: #12c444 !important;
                }
                .span1 {
                    color: #ff0000;
                }
            }
            .btn1 {
                cursor: pointer;
                display: inline-block;
                padding: 0 20px;
                height: 31px;
                line-height: 29px;
                color: #4195f2;
                border: 1px solid #4195f2;
                border-radius: 16px;
                box-sizing: border-box;
            }
            .btn2 {
                color: #fff;
                background: #4195f2;
            }
            .btn3 {
                border: 0;
                color: #fff;
                background: #cccccc;
            }
            .btn4 {
                border: 0;
                color: #fff;
                background: #999;
            }
            &:last-child {
                .stepNum {
                    border: none;
                }
            }
        }
    }

    //遮罩层
    .dialogClose {
        position: relative;
        width: 100%;
        height: 30px;
        i {
            position: absolute;
            right: 20px;
            top: 0px;
            font-size: 30px;
            color: #4195f2;
        }
    }

    .diaTitle {
        text-align: center;
        color: #4195f2;
        font-size: 30px;
    }

    .Exercise {
        margin-top: 50px;
        margin-bottom: 50px;
        display: flex;
        justify-content: space-around;
    }

    .exerciseItem {
        position: relative;
        width: 303px;
        height: 344px;
        color: #fff;
        background: linear-gradient(90deg, #8555ff 0%, #b591ff 100%);
        box-shadow: 0px 7px 16px 0px rgba(88, 42, 197, 0.44);
        border-radius: 10px;
        &:nth-child(2) {
            background: linear-gradient(90deg, #6f70fe 0%, #9d9dff 100%);
            box-shadow: 0px 7px 16px 0px rgba(23, 24, 185, 0.3);
        }
        &:nth-child(3) {
            background: linear-gradient(90deg, #029aff 0%, #68cbff 100%);
            box-shadow: 0px 7px 16px 0px rgba(8, 117, 189, 0.44);
        }
    }

    .itemIcon {
        position: absolute;
        top: 10px;
        right: 10px;
        width: 25px;
        height: 22px;
        cursor: pointer;
    }

    .kong {
        height: 20px;
    }

    .exerciseTop {
        height: 100px;
        text-align: center;
        .exerciseNum {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 18px;
            font-weight: bold;
        }
        .exerciseLogo {
            width: 46px;
            height: 47px;
            margin-right: 20px;
        }
        .explain {
            margin-top: 15px;
            margin-bottom: 15px;
        }
    }

    .exerciseBottom {
        margin-left: 25px;
        margin-right: 25px;
        .line {
            height: 1px;
            opacity: 0.3;
            background-color: #ffffff;
        }
        // 练习封面
        .btmItem {
            display: flex;
            flex-wrap: wrap;
            div {
                margin-top: 15px;
                width: 50%;
            }
        }
        // 做题记录
        .btmItem1 {
            margin-top: 10px;
            height: 140px;
            overflow-x: hidden; /* 解决左右可以滑动的问题 */
            overflow-y: auto;
            .recordItem {
                display: flex;
                justify-content: space-between;
                margin-bottom: 10px;
                div {
                    margin-right: 10px;
                }
            }
        }
        // 暂无做题记录
        .without {
            text-align: center;
            padding-top: 40px;
        }
    }

    // 修改滚动条样式
    div::-webkit-scrollbar {
        width: 4px;
        height: 5px;
    }

    div::-webkit-scrollbar-track {
        background: rgba(191, 191, 191, 0.2);
        border-radius: 4px;
    }

    div::-webkit-scrollbar-thumb {
        background: #fff;
        border-radius: 4px;
    }

    .one::-webkit-scrollbar {
        width: 4px;
        height: 5px;
    }

    .one::-webkit-scrollbar-track {
        background: rgba(191, 191, 191, 0.4);
        border-radius: 4px;
    }

    .one::-webkit-scrollbar-thumb {
        background: rgba(191, 191, 191, 0.6);
        border-radius: 4px;
    }

    .diaBtn {
        position: absolute;
        left: 50%;
        bottom: 20px;
        transform: translateX(-50%);
        display: inline-block;
        width: 112px;
        height: 38px;
        line-height: 38px;
        background-color: rgba(255, 255, 255, 0.4);
        color: #fff;
        border-radius: 19px;
        text-align: center;
        cursor: pointer;
    }

    .diaBtn1 {
        background-color: #fff;
        color: #4195f2;
    }

    .tip {
        font-size: 14px;
        text-align: center;
        color: #4195f2;
    }

    // 内部遮罩层
    /deep/ .el-dialog__footer {
        padding: 0;
    }

    /deep/ .dialogOne {
        border-radius: 15px;
        overflow: hidden;
    }

    .con {
        margin: 30px 0;
        color: #333;
        font-size: 22px;
        font-weight: 500;
    }

    .interiorFooter {
        display: flex;
        height: 45px;
        line-height: 45px;
        cursor: pointer;
        div {
            width: 50%;
            font-size: 18px;
            text-align: center;
            color: #4195f2;
        }
        .btn {
            background-color: #4195f2;
            color: #fff;
        }
    }

    /deep/ .dialogTwo {
        border-radius: 16px;
    }

    /deep/ .dialogTwo .el-dialog__body {
        padding: 0;
    }

    /deep/ .dialogTwo-inside {
        border-radius: 16px;
        overflow: hidden;
    }

    /deep/ .dialogTwo-inside .el-dialog__body {
        padding: 0 20px;
    }

    .bgc {
        height: 580px;
        background-image: url("../../assets/img/study/exam/bg_1_9.png");
        background-repeat: no-repeat;
    }

    // 遮罩层2
    .dialogClose1 {
        height: 45px;
        margin-bottom: 10px;
        i {
            margin-top: 15px;
            color: #fff;
        }
    }

    .dialog2 {
        color: #fff;
        width: 980px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-left: 170px;
        margin-right: 50px;
        height: 500px;
    }

    .dialogLeft2 {
        width: 584px;

        font-size: 18px;
        .leftTop2 {
            text-align: center;
            div {
                margin-top: 8px;
                &:first-child {
                    font-size: 30px;
                }
            }
        }
        .leftMid2 {
            margin-top: 10px;
            padding: 30px;
            height: 215px;
            overflow: auto;
            border-radius: 10px;
            font-size: 16px;
            background: rgba(255, 255, 255, 0.1);
            line-height: 30px;
        }
        .leftBtn2 {
            margin: 20px 0;
            display: flex;
            justify-content: space-around;
            div {
                width: 160px;
                height: 50px;
                line-height: 50px;
                background: #ffffff;
                border-radius: 10px;
                color: #4195f2;
                text-align: center;
                cursor: pointer;
                &:last-child {
                    color: #fff;
                    border: 1px solid #fff;
                    background: transparent;
                }
            }
        }
        .leftBottom2 {
            text-align: center;
            font-size: 14px;
        }
    }

    .dialogRight2 {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        width: 268px;
        height: 324px;
        padding: 30px;
        font-size: 16px;

        background: rgba(255, 255, 255, 0.1);
        .dialogRight2-img {
            width: 50px;
            height: 50px;
        }
    }

    .leftMidList2 {
        margin-bottom: 35px;
        display: flex;
        justify-content: space-between;
        .leftMid2-left {
            display: flex;
            align-items: center;
            div {
                margin-right: 10px;
            }
            .leftMid2-leftImg {
                width: 20px;
                height: 20px;
            }
        }
        .leftMid2-right {
            color: #54a0f3;
            text-align: center;
            width: 80px;
            height: 30px;
            background: #ffffff;
            border-radius: 5px;
            box-sizing: border-box;
            cursor: pointer;
        }
        .leftMid2-right:hover {
            background: transparent;
            border: 1px solid #fff;
            color: #fff;
        }
        &:last-child {
            margin-bottom: 0;
        }
    }
</style>
